import NextLink from 'next/link';

import CollectionLogo from 'components/base/CollectionLogo';
import Grid from 'components/base/Grid';

import { ApiMarketNftGridFields } from 'gql/api/api-fragments.generated';
import { buildArtworkPath } from 'utils/artwork/artwork';
import { getUsernameOrTruncatedAddress, hasUsername } from 'utils/helpers';

import type { Account, UserLight } from 'types/Account';

import SearchResultElement from './search-result/SearchResultElement';
import SearchResultHeading from './search-result/SearchResultHeading';
import SearchResultSubheading from './search-result/SearchResultSubheading';

interface SearchHitArtworkProps {
  hit: ApiMarketNftGridFields;
  onClick: (arg0: ApiMarketNftGridFields) => void;
}

export default function SearchHitArtwork(props: SearchHitArtworkProps) {
  const { hit, onClick } = props;

  const user: UserLight = {
    publicKey: hit.creator.publicKey,
    username: hit.creator.username,
    profileImageUrl: null,
    name: null,
  };

  const usernameOrTruncatedAddress = getUsernameOrTruncatedAddress(user);
  const userHasUsername = hasUsername(user);

  const creator: Pick<Account, 'publicKey' | 'username'> = {
    publicKey: hit.creator.publicKey,
    username: hit.creator.username,
  };

  const isUnsupportedAsset = true;

  return (
    <NextLink
      href={buildArtworkPath({ artwork: hit, user: creator })}
      prefetch={false}
      passHref
      legacyBehavior
    >
      <SearchResultElement as="a" onClick={() => onClick(hit)}>
        <CollectionLogo
          imageUrl={null}
          css={{
            background: isUnsupportedAsset ? '$black100' : undefined,
            marginRight: '$4',
          }}
          size={4}
          disableImgixOptimization
        />
        <Grid css={{ alignItems: 'center', gap: '$1' }}>
          <SearchResultHeading>{hit.name}</SearchResultHeading>
          <SearchResultSubheading isMono={!userHasUsername}>
            {usernameOrTruncatedAddress}
          </SearchResultSubheading>
        </Grid>
      </SearchResultElement>
    </NextLink>
  );
}
